/**
 * The meal's "based on" marker (`basedOnFoodId`) after foods from a past meal or a recipe went
 * into it (#6188).
 *
 * The marker names the recipe or past meal a meal was built from. The meal screen shows it as the
 * "Based on ..." line and the recipe's instructions, and uses it as Auto-Tune's source.
 *
 * The rule, settled by the product owner on 2026-10-04: foods that go into an EMPTY meal bring
 * the source's marker with them, whatever kind of marker it is -- a pointer to one past meal is
 * passed on as it is (whether such pointers should exist at all is mh-physique#6192). Foods added
 * to a meal that already holds food change nothing: that meal is not "based on" the source, it
 * only contains some of it.
 *
 * Callers that offer Undo remember the marker from before and put it back themselves.
 */
export function markerAfterAdding(
  mealWasEmpty: boolean,
  currentMarker: string | undefined,
  sourceMarker: string | undefined,
): string | undefined {
  return mealWasEmpty && sourceMarker ? sourceMarker : currentMarker;
}
